<div class="bg-background flex-1 overflow-y-auto overflow-x-hidden">
    <app-tab
        [tabs]="tabs()"
        [translateTabs]="false">
        @for (category of controlsGroupedByCategory(); track category.key) {
            <ng-template appTabContent>
                @for (groupControls of category.groupedControls; track groupControls.key) {
                    <app-field-intervention-form-grouped-controls
                        [controlResults]="fieldInterventionControlResults()"
                        [controlsGroup]="groupControls"
                        [isExpanded]="$first"
                        [isLoading]="isLoading()"
                        [isResultRequired]="isResultRequired()"
                        (controlResultUpdated)="updateControlResult($event)" />
                }
            </ng-template>
        }
    </app-tab>
</div>
